<template>
  <div class="common-footer" :class="{ mobile: ismobile }">
    <div class="common-footer-content">
      <img
        class="common-footer-logo"
        :src="logoUrl"
        :class="{ small: footerContent }"
        alt=""
      />
      <div class="common-footer-links">
        <p>
          <a
            class="common-footer-link"
            :href="termUrl"
            v-if="serverTermState"
            v-html="letter.termsOfUse"
            target="_blank"
          ></a>

          <a
            class="common-footer-link"
            :href="privicyUrl"
            v-if="privacyTermState"
            v-html="letter.privacyPolicy"
            target="_blank"
          ></a>
        </p>
        <p class="copyright" v-if="footerContent">{{ footerContent }}</p>
        <p v-html="copyright" class="copyright"></p>
      </div>
    </div>
  </div>
</template>

<script>
import LogoUrl from '../../mixins/LogoUrl'
import LinkTermUrl from '../../mixins/LinkTermUrl'
import globalConfig from '../../utiles/globalConfig'
const mainHost = globalConfig.getMainHost()

const FOOTER_CONTENT = {
  common: '',
  kr: '결제내역문의(PL고객센터) : 1599-7591'
}

export default {
  name: 'FooterCommonGlobal',
  data() {
    return {
      ismobile: window.isPhone,
      footerContent: FOOTER_CONTENT[window.pageInfo['footerContent']] || '',
      copyright:
        window.pageInfo['copyright'] ||
        `Copyright © www.${mainHost} All rights reserved.`
    }
  },
  mixins: [LogoUrl, LinkTermUrl]
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_dimen.scss';
.common-footer {
  background: white;
  width: 100%;
  display: block;
  box-sizing: border-box;
  &-content {
    width: 90%;
    padding: 36vh 0;
    margin: auto;
    position: relative;
  }
  &-logo {
    height: 60%;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    &.small {
      height: 40%;
    }
  }
  &-links {
    text-align: right;
    color: black;
    font-size: 16vh;
    p {
      margin: 0;
    }
  }
  .copyright {
    margin-top: 6vh;
  }
  &-link {
    color: black;
    text-decoration: none;
    position: relative;
    margin-left: 30vh;
    font-size: 16vh;
    &::before {
      content: '';
      position: absolute;
      width: 1px;
      height: 80%;
      background: black;
      left: -15vh;
      top: 10%;
    }
    &:first-child {
      &::before {
        display: none;
      }
    }
    &:hover {
      color: $blue;
      cursor: pointer;
    }
  }
  &.mobile {
    padding: 30vh 0;
    .common-footer-content {
      width: 100%;
      padding: 0;
    }
    .common-footer-logo {
      height: 50vh;
      display: block;
      margin: auto;
      position: initial;
      transform: none;
    }
    .common-footer-links {
      margin-top: 10vh;
      text-align: center;
    }
  }
}
</style>
